/* @flow */
import React from 'react';
import Heading from 'components/Heading.jsx';
import Text from 'components/Text.jsx';

class DeliveryModalList extends React.Component {
  static propTypes = {
    title: React.PropTypes.string.isRequired,
    subtext: React.PropTypes.string,
  };

  render() {
    const { title, subtext, children } = this.props;

    return (
      <div className="DeliveryModalList">
        <Heading align="left" level="3">
          {title}
        </Heading>
        {
          subtext &&
            <Text color="thunder" element="p" size="xxsmall">
              {subtext}
            </Text>
        }
        <ul>
          {children}
        </ul>
      </div>
    );
  }
}

export default DeliveryModalList;



// WEBPACK FOOTER //
// ./src/chat/components/DeliveryModalList.jsx